import './style.css';
import React, { useEffect, useState } from 'react'
import { createTimeString, numberToCash, auth, getOrderStatus } from '../../../libs/lib';
import { BASE_ROUTE, DEFAULT_ROWS, SESSION_EXPIRED_CODE, ROOT_ADDR } from '../../../config';
import { Button, Collapse, FormControl, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";
import Progress from '../../../components/progress';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { http_request } from '../../../libs/connection';
import QRCode from 'react-qr-code';
import Filter from '../../../components/filter';

const PAGE_SIZE = 100;
const INIT = 0;
const SEARCH = 1;
const MANUALLY = 2;
var param_status;
var page = 1;

const OutsourcingList = () => {
  const [search_params, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [start_date, setStartDate] = useState((function(){ let d = new Date(); d.setMonth(d.getMonth() - 2); return d; })());
  const [end_date, setEndDate] = useState(new Date());
  const [total, setTotal] = useState(0);
  const [switch_checked, checkSwitch] = useState(search_params.get('filter_on') === '1');
  const [search, setSearch] = useState('');
  const [el_search, setElSearch] = useState('');
  const [is_loading, setLoadingStatus] = useState(false);
  const [list, setList] = useState([]);
  const [ship_orders, setShipOrders] = useState([]);
  const [reject_orders, setRejectOrders] = useState([]);
  const [editing_order, setEditingOrder] = useState({});
  const [qc_remk, setQCRemk] = useState('');
  const [company_fd_no, setCompanyFDNo] = useState('');
  const [filter_show, showFilter] = useState(false);
  const [ship_order_list_viewer_show, showShipOrderListViewer] = useState(false);
  const [reject_order_list_viewer_show, showRejectOrderListViewer] = useState(false);
  const [order_editor_show, showOrderEditor] = useState(false);
  const [success_toast_show, showSuccessToast] = useState(false);
  const [error_toast_show, showErrorToast] = useState(false);
  const [success_message, setSuccessMessage] = useState('');
  const [error_message, setErrorMessage] = useState('');

  useEffect(()=>{
    param_status = (search_params.has('start_date') || search_params.get('search') || search_params.get('el_search')) ? SEARCH : INIT;
    if(param_status === INIT){
      resetParams();
    }
    page = 1;
    loadData();
  }, [pathname]);


  useEffect(()=>{
    if(location.search === ''){
      param_status = INIT;
      resetParams();
      loadData();
    }
  }, [location.search]);

  useEffect(()=>{
    page = 1;
    loadData();

    //當switch切換時更新網址參數
    let new_param = {};
    search_params.forEach(function(value, key){ if(value) new_param[key] = value });
    new_param.filter_on = switch_checked ? '1' : '';
    setSearchParams(new_param);
  }, [switch_checked]);

  function resetParams(){
    resetDate();
    resetSearch();
    page = 1;
  }
  function resetDate(){
    setStartDate((function(){ let d = new Date(); d.setMonth(d.getMonth() - 2); return d; })());
    setEndDate(new Date());
  }
  function resetSearch(){
    setSearch('');
    setElSearch('');
  }
  function loadData(){
    if(is_loading) return;
    /*
      查询之前检查状态并决定赋什麽值

      状态分三种：初始(预设参数)、网址设置参数、手动设置参数

      参数优先级分别为：手动参数 > 网址参数 > 预设参数

      页面开始执行时(监听 pathname)，变更状态
      每次手动调整参数后，变更状态

      每次查询后，变更网址参数
    */
    let start_date_value, end_date_value, search_value, el_search_value;
    switch(param_status){
      case INIT:
        start_date_value = createTimeString('y-m-d h:i:s', start_date);
        end_date_value = createTimeString('y-m-d h:i:s', end_date);
      break;
      case SEARCH:
        start_date_value = search_params.get('start_date');
        end_date_value = search_params.get('end_date');
        search_value = search_params.get('search');
        el_search_value = search_params.get('el_search');
        setStartDate(new Date(start_date_value));
        setEndDate(new Date(end_date_value));
        setSearch(search_value);
        setElSearch(el_search_value);
      break;
      case MANUALLY:
        start_date_value = createTimeString('y-m-d h:i:s', start_date);
        end_date_value = createTimeString('y-m-d h:i:s', end_date);
        search_value = search;
        el_search_value = el_search;
      break;
    }
    
    let params = {
      start: createTimeString('y-m-d ', start_date_value),
      end: createTimeString('y-m-d ', end_date_value),
      page,
      rows: DEFAULT_ROWS
    };
    if(search_value) params.search = search_value;
    if(el_search_value) params.el_no = el_search_value;
    if(switch_checked){
      params.completed = 0;
      params.rows = PAGE_SIZE;
    }

    setLoadingStatus(true);
    http_request('/outsourcingOrder/list', 'POST', params).then(res=>{
      const ORDER_COLUMNS = ['os_odno', 'os_prdat', 'cu_no', 'cu_name', 'color', 'sort', 'remark'];
      setLoadingStatus(false);
      if(res.success){
        let data = res.data.outsourcing_orders || [];

        //勾了未出貨 filter 的情況，送來的 response 是散的，每筆一個料，而不是每筆一張訂單，所以要先合併，在往下走流程
        if(switch_checked){
          let temp_data = new Map();
          data.forEach(row=>{
            if(!row.el_no) return;
            let key = row.os_odno;
            let temp_item
            if(temp_data.has(key)){
              temp_item = temp_data.get(key);
              for(let c of ORDER_COLUMNS) delete row[c];
              temp_item.details.push(row);
              temp_data.set(key, temp_item);
            }else{
              temp_item = {};
              for(let c of ORDER_COLUMNS){
                temp_item[c] = row[c];
                delete row[c];
              }
              temp_item.details = [row];
              temp_data.set(key, temp_item);
            }
          });
          data = [...temp_data.values()];
        }
        if(page === 1){
          setList(data);
        }else{
          setList([...list, ...data]);
        }
        setTotal(res.data.total);
      }else if(res.message === SESSION_EXPIRED_CODE){
        navigate(`${BASE_ROUTE}/logout`);
      }
    });
  }
  function query(){
    param_status = MANUALLY;
    page = 1;
    let params = {
      start_date: createTimeString('y/m/d', start_date),
      end_date: createTimeString('y/m/d', end_date),
    };
    if(search) params.search = search;
    if(el_search) params.el_search = el_search;
    if(switch_checked) params.filter_on = '1';
    setSearchParams(params);
    loadData();
  }
  function loadMore(e){
    if(page * DEFAULT_ROWS <= total){
      page += 1;
      loadData();
    }
  }

  function loadOrderDetail(order){
    let params = {
        os_odno: order.os_odno
    };
    setLoadingStatus(true);
    http_request('/outsourcingOrder/get', 'POST', params).then(res=>{
        setLoadingStatus(false);
        if(res.success){
            let raw_data = res.data.outsourcing_orders;
            order.detail = raw_data.filter(od=>od.flag !== 'D').map(row=>{
              let r = Object.assign({}, row);
              r.ch_qty2_number = calculateQtyNumber(row);
              return r;
            });
            for(let i = 0 ; i < order.detail.length ; i++){
                delete order.detail[i].detail;
            }
            setEditingOrder(order);
        }else if(res.message === SESSION_EXPIRED_CODE){
            navigate(`${BASE_ROUTE}/logout`);
        }
    })
}
  function loadShipOrders(os_odno){
      if(!auth("global.outsourcingShipOrder")) return;
      let params = {
        os_odno,
        rows: 9999
      };
      setLoadingStatus(true);
      http_request('/outsourcingShipOrder/list', 'POST', params).then(res=>{
        setLoadingStatus(false);
        if(res.success){
            setShipOrders(res.data.outsourcing_ship_orders || []);
        }else if(res.message === SESSION_EXPIRED_CODE){
            navigate(`${BASE_ROUTE}/logout`);
        }
      })
  }
  function loadRejectOrders(os_odno){
      let params = {
          os_odno,
          rows: 9999
      };
      setLoadingStatus(true);
      http_request('/outsourcingRejectOrder/list', 'POST', params).then(res=>{
        setLoadingStatus(false);
        if(res.success){
            setRejectOrders(res.data.outsourcing_reject_orders || []);
        }else if(res.message === SESSION_EXPIRED_CODE){
            navigate(`${BASE_ROUTE}/logout`);
        }
      })
  }
  function submitOrder(){
    if(!company_fd_no?.length || company_fd_no?.length > 20){
      setErrorMessage('出货单号不可留白');
      showErrorToast(true);
      return;
    }
    let params = {
        os_odno: editing_order.os_odno,
        qc_remk,
        company_fd_no,
        qc_qty2: editing_order.detail[0].qc_qty2_number
    };
    
    setLoadingStatus(true);
    http_request('/outsourcingOrder/ship', 'POST', params).then(res=>{
        setLoadingStatus(false);
        if(res.success){
            showOrderEditor(false);
            showSuccessToast(true);
            setSuccessMessage('已建立出货单');
            setErrorMessage('');
            let new_list = [...ship_orders];
            new_list.push(res.data.outsourcing_ship_order);
            setShipOrders(new_list);
        }else if(res.message === SESSION_EXPIRED_CODE){
            showOrderEditor(false);
            navigate(`${BASE_ROUTE}/logout`);
        }else{
            showErrorToast(true);
            setErrorMessage(res.message);
        }
    })
  }
  function popShipOrderEditor(order){
    let new_form = Object.assign({}, order);
    new_form.detail = [...(new_form.detail || [])];
    loadOrderDetail(new_form);
    setQCRemk('');
    setCompanyFDNo('');
    showOrderEditor(true);
  }
  function popShipOrderList(order){
    loadShipOrders(order.os_odno);
    showShipOrderListViewer(true);
  }
  function popRejectOrderList(order){
    loadRejectOrders(order.os_odno);
    showRejectOrderListViewer(true);
  }
  function deleteShipOrder(fd_no, i){
      let rs = window.confirm(`确定删除出货单吗?`);
      if(!rs) return;

      let params = { fd_no };
      setLoadingStatus(true);
      http_request('/outsourcingShipOrder/delete', 'POST', params).then(res=>{
          setLoadingStatus(false);
          if(res.success){
              showSuccessToast(true);
              setSuccessMessage('已删除出货单');
              setErrorMessage('');
              let new_list = [...ship_orders];
              new_list.splice(i, 1);
              setShipOrders(new_list);
          }else if(res.message === SESSION_EXPIRED_CODE){
              navigate(`${BASE_ROUTE}/logout`);
          }else{
              showErrorToast(true);
              setErrorMessage(res.message);
          }
      });
  }
  function calculateQtyNumber(row){
    let n = row.os_qty2 - row.os_puqty + row.os_reqty + row.os_reqty2;
    if(n < 0) n = 0;
    return n;
  }
  return (
    <div id="page-outsourcing-list" className={`page`}>
      <Progress show={is_loading} />
      <Modal
          show={order_editor_show}
          onHide={()=>{ showOrderEditor(false); }}
          size='lg'
      >
          <Modal.Header>
              <span className='fs-5'>建立出货单</span>
          </Modal.Header>
          <Modal.Body>
              <table>
                  <tbody>
                      <tr>
                          <td>{editing_order.os_odno}</td>
                      </tr>
                      <tr>
                          <td>{editing_order.ch_date}</td>
                      </tr>
                      <tr>
                          <td>{editing_order.cu_name}</td>
                      </tr>
                  </tbody>
              </table>
              <div>
                  {
                      (editing_order.detail || []).map((row, r)=><div key={r} className={`p-3 mt-2 border`}>
                          <ul className=''>
                              <li>{row.ch_seq}</li>
                              <li>{row.el_name1}</li>
                              <li>{row.ch_apno}</li>
                              <li>{row.el_no}</li>
                              <li>出货数量上限：{calculateQtyNumber(row)}</li>
                              <li>出货数量：<input 
                                  style={{ width: 80 }}
                                  value={row.qc_qty2_number || ''} 
                                  onChange={e=>{
                                      var v = e.currentTarget.value;
                                      let new_form = Object.assign({}, editing_order);
                                      new_form.detail = [...(new_form.detail || [])];
                                      new_form.detail[r].qc_qty2_number = v;
                                      setEditingOrder(new_form);
                              }} />{row.ch_unit}</li>
                              <li>单价：{numberToCash(row.ch_price)}</li>
                          </ul>
                      </div>)
                  }
              </div>
              <div className='mt-3'>
                  <FormControl
                    className='mb-2'
                    placeholder="厂商出货单号(至多20码)"
                    value={company_fd_no}
                    maxLength={20}
                    onChange={e=>{
                        setCompanyFDNo(e.currentTarget.value.toUpperCase());
                    }}
                  />
                  <FormControl
                      as="textarea"
                      rows={4}
                      value={qc_remk}
                      onChange={e=>{
                          setQCRemk(e.currentTarget.value);
                      }}
                      placeholder='备註'
                  />
              </div>
          </Modal.Body>
          <Modal.Footer className='f-flex justify-content-between'>
              <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showOrderEditor(false); }}>取消</Button>
              <Button 
                  size='sm' 
                  variant='success' 
                  className='px-3'
                  disabled={(editing_order.detail || []).filter(row=>row.qc_qty2_number).length === 0}
                  onClick={()=>{ submitOrder(); }}
              >建立出货单</Button>
          </Modal.Footer>
      </Modal>
      <Modal
          show={ship_order_list_viewer_show}
          onHide={()=>{ showShipOrderListViewer(false); }}
          centered
      >
          <Modal.Body className='p-5 d-flex flex-column align-items-center justify-content-center'>
              {
                  ship_orders.map((ship_order, s)=><div key={s} className="qr_block">
                      <QRCode
                          size={256}
                          className='qr-code mb-2'
                          value={`${ROOT_ADDR}/erp/outsourcing/ship/detail/${ship_order.fd_no}`}
                      />
                      <div className='fw-bold'>{ship_order.fd_no}</div>
                      <div>建立日期：{createTimeString('y-m-d', ship_order.date)}</div>
                      <div>签收日期：{ship_order.fd_date ? createTimeString('y-m-d', ship_order.fd_date) : '--'}</div>
                      <div>签收状态：[{getOrderStatus(ship_order.temp_no, ship_order.result)}]{ship_order.temp_no ? '已签收' : (ship_order.result ||'').replace(/^\d+\./, '')}</div>
                      <div>厂商出货单号：{ship_order.company_fd_no || '--'}</div>
                      <div className='mb-3'>备註：{ship_order.qc_remk}</div>
                      <div className='mb-3 mt-1 d-flex align-items-center justify-content-between'>
                          <Button 
                              variant='danger' 
                              size='sm' 
                              className='px-2'
                              onClick={()=>{
                                  deleteShipOrder(ship_order.fd_no, s);
                              }}
                              disabled={getOrderStatus(ship_order.temp_no, ship_order.result) !== '尚未签收'}
                          >
                              删除出货单
                          </Button>
                          <Button 
                              variant='success' 
                              size='sm' 
                              className='px-4'
                              onClick={()=>{
                                  navigate(`${BASE_ROUTE}/outsourcing/ship/detail/${ship_order.fd_no}`);
                              }}
                          >
                              打开出货单
                          </Button>
                      </div>
                  </div>)
              }
              {
                ship_orders.length === 0 ? <div>无出货单</div> : ''
              }
          </Modal.Body>
          <Modal.Footer className='d-flex align-items-center justify-content-end'>
              <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showShipOrderListViewer(false); }}>关闭</Button>
          </Modal.Footer>
      </Modal>
      <Modal
          show={reject_order_list_viewer_show}
          onHide={()=>{ showRejectOrderListViewer(false); }}
          centered
      >
          <Modal.Body className='p-5 d-flex flex-column align-items-center justify-content-center'>
              {
                  reject_orders.map((reject_order, s)=><div key={s} className="qr_block">
                      <div className='fw-bold'>{reject_order.fd_no}</div>
                      <div>建立日期：{createTimeString('y-m-d', reject_order.date)}</div>
                      <div className='mb-3'>备註：{reject_order.qc_remk}</div>
                      <div className='mb-3 mt-1'>
                          <Button 
                              variant='success' 
                              size='sm' 
                              className='px-4'
                              onClick={()=>{
                                  navigate(`${BASE_ROUTE}/outsourcing/reject/detail/${reject_order.fd_no}`);
                              }}
                          >
                              打开明细
                          </Button>
                      </div>
                  </div>)
              }
              {
                reject_orders.length === 0 ? <div>无拒收记录</div> : ''
              }
          </Modal.Body>
          <Modal.Footer className='d-flex align-items-center justify-content-end'>
              <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showRejectOrderListViewer(false); }}>关闭</Button>
          </Modal.Footer>
      </Modal>
      <ToastContainer 
          position='middle-bottom'
          style={{ zIndex: 1056 }}
          >
          <Toast 
              show={success_toast_show} 
              onClose={()=>{ showSuccessToast(false); }}
              delay={2000}
              autohide
              bg="success"
              className='text-white'
          >
              <Toast.Header>
                  <strong className="me-auto">已完成</strong>
              </Toast.Header>
              <Toast.Body>{success_message}</Toast.Body>
          </Toast>
      </ToastContainer>
      <ToastContainer
          position='middle-bottom'
          style={{ zIndex: 1056 }}
      >
          <Toast 
              show={error_toast_show} 
              onClose={()=>{ showErrorToast(false); }}
              delay={3000}
              autohide
              bg="danger"
              className='text-white'
          >
              <Toast.Header>
                  <strong className="me-auto">建立失败</strong>
              </Toast.Header>
              <Toast.Body>{error_message}</Toast.Body>
          </Toast>
      </ToastContainer>
      <div className={`datepicker_pannel bg-white p-3`}>
        <div className='d-lg-none d-flex align-items-center'>
          <span className='fs-6'>外包单查询</span>
          <span className='d-flex flex-grow-1 align-items-center justify-content-end' onClick={()=>{ showFilter(!filter_show); }}>
            {
              filter_show ? <BsChevronCompactUp /> : <BsChevronCompactDown />
            }
          </span>
        </div>
        <Collapse in={filter_show}>
          <div>
            <div className='d-block d-lg-none'>
              <Filter 
                switch_checked={switch_checked}
                checkSwitch={checkSwitch}
                switch_label="显示尚未出货完成"
                search={search}
                el_search={el_search}
                start_date={start_date}
                end_date={end_date}
                setSearch={setSearch}
                setElSearch={setElSearch}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                query={query}
              />
            </div>
          </div>
        </Collapse>
        <div className='d-none d-lg-block'>
          <Filter 
            switch_checked={switch_checked}
            checkSwitch={checkSwitch}
            switch_label="显示尚未出货完成"
            search={search}
            el_search={el_search}
            start_date={start_date}
            end_date={end_date}
            setSearch={setSearch}
            setElSearch={setElSearch}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            query={query}
          />
        </div>
      </div>
      <div className={`container p-2 d-flex flex-column`}>
        {
          (list || []).length === 0 && <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
            <span className='text-secondary'>无资料</span>
          </div>
        }
        <ul className='m-0 p-0'>
          {
            
            list.map((row, r)=><li key={r} className={`item mb-2 p-3`}>
                <div className='p-2' style={{ backgroundColor: row.color || 'transparent' }}>
                  <div className='id'>{row.os_odno}</div>
                  <div className='date'>{row.os_prdat}</div>
                  {
                    row.remark ? <div className='text-primary fs-6'>{row.remark}</div> : <></>
                  }
                  <div className={`sales ${(row.el_no && !switch_checked) ? '' : 'mb-3'}`}>{row.cu_name}</div>
                  {
                    row.el_no ? <>
                      <div className='info'>料品编号：{row.el_no}</div>
                      <div className='info'>料品名称：{row.el_name1}</div>
                      <div className='info'>採购数量：{row.os_qty2}</div>
                      <div className='info'>拒收数量：{row.os_reqty}</div>
                      <div className='info'>退货数量：{row.os_reqty2}</div>
                      <div className='info'>出货数量：{row.os_puqty}</div>
                      <div className='info mb-3'>实收数量：{row.os_puqty - row.os_reqty - row.os_reqty2}</div>
                    </> : <></>
                  }
                  {
                    row.details ? <table className='detail w-100 mb-3'>
                      <thead>
                        <tr>
                          <th>料品编号</th>
                          <th>料品名称</th>
                          <th className='text-center'>未出货数量</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          row.details.map((detail, d)=><tr key={d}>
                            <td>{detail.el_no}</td>
                            <td>{detail.el_name1}</td>
                            <td className='text-center'>{detail.os_qty2 - (detail.os_puqty - detail.os_reqty - detail.os_reqty2)}</td>
                          </tr>)
                        }
                      </tbody>
                    </table> : <></>
                  }
                </div>
                <div className='d-flex align-items-start justify-content-start'>
                  <div className='pt-3'>
                    <Button 
                      size="sm" 
                      variant='success' 
                      className='px-2 me-2 mb-2 list-button' 
                      onClick={()=>{
                        navigate(`${BASE_ROUTE}/outsourcing/detail/${row.os_odno}`);
                      }}
                    >明细</Button>
                      <Button
                        size="sm"
                        variant='warning'
                        className='px-2 me-2 mb-2 list-button'
                        onClick={()=>{ popShipOrderEditor(row); }}
                      >建立出货单</Button>
                    {
                      auth("global.outsourcingShipOrder") && <Button
                          size="sm"
                          variant='danger'
                          className='px-2 me-2 mb-2 list-button'
                          onClick={()=>{ popShipOrderList(row); }}
                        >出货单列表</Button>
                    }
                  </div>
                </div>
            </li>)
          }
        </ul>
        <div className='d-flex align-items-center justify-content-center py-4'>
          {
            (page * DEFAULT_ROWS < total) &&<Button 
              variant='warning' 
              size="sm" 
              className='px-5' 
              onClick={()=>{ loadMore(); }}
            >
              MORE
            </Button>
          }
        </div>
      </div>
    </div>
  )
}


export default OutsourcingList